import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import Iframe from 'react-iframe';
import Chatbox from './ChatBox';
import ChatboxChi from './ChatBoxChi';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import ReadPDFResponse from './ReadPDFResponse'
import axios from 'axios';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    container: {
        // margin: theme.spacing.unit * 5,
        //width: '50%',
        //minwidth: '30%',
        width: 400,
        height: 250,
        maxHeight: 300,
        minHeight: 200,
        //top: '10%',
        // left: '10%',
    },
    sigContainer: {
        maxWidth: '100%',
        minwidth: '30%',
        height: '80%',
        alignItems:'left',
        backgroundColor: '#fff',
    },
    button: {
        //width: '100%',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    },
    containern:{
        float: 'left',
        width:'50%',
        '@media (max-width: 576px)': {
            width: '100%'
          }
    }
});

class ChatbotResponse extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: localStorage.getItem('token'),
        typeOfAccount:localStorage.getItem('typeOfAccount'),
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth,
        widthpercent:'50%'
    }

    openInNewWindow(caseId){
        console.log('openInNewWindow caseId: '+caseId);
        // window.open(__dirname+'chatbot_response.html?caseId='+caseId,"_self");
    }

    switchReEnterData= () => {

        if(this.props.claimantUniqueId == this.state.uniqueId){
            this.setState({
                userType:'claimant'
            })
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            this.setState({
                userType:'respondent'
            })
        }

        if (this.state.userType == 'claimant'){
            // this.setState({
            //     reEnterData: (!this.state.reEnterData)
            // })
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpirationDate');
            localStorage.removeItem('caseId');
            window.open('https://www.hkarbsoc.org.hk/odr','_blank');
            // window.open('/odr/#/reenterdata/')
        }
        else if (this.state.userType == 'respondent'){
            this.props.changeResponseToReEnter(this.props.caseId)
        }
    }

    componentDidMount(){
        this.handleResize();
        window.addEventListener("resize", this.handleResize);
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/respondentChatbotStatus`;
        let payload = {
            caseId: this.props.caseId,
            status: 'add'
        }
        
        axios.post(url, payload)
        .then((response) => {
            console.log('add response: '+JSON.stringify(response))
            if(response.data === 'added'){
                setInterval(()=>{
                    let url2 = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/respondentChatbotStatus`;
                    let payload2 = {
                        caseId: this.props.caseId,
                        status: 'check'
                    }
                    
                    axios.post(url2, payload2)
                    .then((response2) => {
                        // console.log('check response: '+JSON.stringify(response2))
                        if(response2.data === 1){

                            let url3 = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/respondentChatbotStatus`;
                            let payload3 = {
                                caseId: this.props.caseId,
                                status: 'delete'
                            }
                            
                            axios.post(url3, payload3)
                            .then((response3) => {
                                console.log('delete response: '+JSON.stringify(response3))
                                if(response3.data === 'deleted'){
                                    window.location.href= "https://www.hkarbsoc.org.hk/odr#/cases/"
                                }
                            })
                            .catch((err)=>{
                                console.log('respondentChatbotStatus err:'+err)
                            })
                        }
                    })
                    .catch((err)=>{
                        console.log('respondentChatbotStatus err:'+err)
                    })
                },2000)
            }
        })
        .catch((err)=>{
            console.log('respondentChatbotStatus err:'+err)
        })
    }

    componentWillUnmount(){

    }

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth,
        });
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 780){
            this.setState({
                widthpercent: '100%'
            })
      }
    }

    render(){
        const { classes } = this.props;
        let { trimmedDataURL } = this.state;

        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        console.log(`Eng FMF check ${userType} ${this.state.uniqueId}`)
 
        let fileURL = __dirname + 'chatbot_response.html?caseId='+this.props.caseId
        console.log('ChatbotResponse caseId: '+this.props.caseId);
        return(
            <div className={classes.card2}>
            {   userType == 'respondent' && this.props.caseData.language == 'Eng' &&
                <div>
                    <div className={classes.containern}>
                        <ReadPDFResponse conversationId={this.props.caseData.conversationId}/>
                    </div>
                    <div className={classes.containern}>
                        <Chatbox caseId={this.props.caseId} width={this.state.widthpercent} style={{width:this.state.widthpercent, marginTop:'60px'}}/>
                    </div>
                </div>
            }

            {   userType == 'respondent' && this.props.caseData.language == 'Chi' &&
                <div>
                     <div className={classes.containern}>
                        <ReadPDFResponse conversationId={this.props.caseData.conversationId}/>
                    </div>
                    <div className={classes.containern}>
                        <ChatboxChi caseId={this.props.caseId} width={this.state.widthpercent} style={{width:this.state.widthpercent, marginTop:'60px'}}/>
                    </div>
                       
                </div>
            }
            {userType !== 'respondent' && "Chatbot completed"}
            </div>  
        );
    }
}

const mapStateToProps = (state) => {
    return {
    isAuthenticated: state.auth.token !== null,
    //userId: state.auth.userId,
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
    claimant_name: state.caseInfo.claimant_name,
    respondent_name: state.caseInfo.respondent_name,
    userType: state.caseInfo.userType,
    conversationId: state.caseInfo.conversationId,
    caseId: state.caseInfo.caseId,
    userType: state.caseInfo.userType,
    loadingCaseInfo: state.caseInfo.loading,
    loadingStepCompleted: state.onBoarding.loading,
    caseData: state.caseInfo.caseData,
    steps_completed: state.caseInfo[`${state.caseInfo.userType}_steps_completed`],
    newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
      onLogout: () => dispatch(actions.logout()),
      onAuth: (username, password) => dispatch(actions.auth(username, password)),
      onBoardingStepCompletion: (uniqueId, caseId, userType, step_completed) => dispatch(actions.onBoardingStepCompletion(uniqueId, caseId, userType, step_completed)),
      getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
      getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
    }
  }

  ChatbotResponse.contextTypes = {
    t: PropTypes.func
}

// export default withStyles(styles)(ChatbotResponse);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(ChatbotResponse)));